import { t } from "../../../i18n";
import PropTypes from 'prop-types';
import { Box, Divider, Drawer, Typography } from '@mui/material';
import { portalConfig } from '../../../configs/portal';
import { portalBrand } from '../../../configs/brand';
import { APP_VERSION } from '../../../version';
import LogoSection from '../LogoSection';
import CompanySection from '../companySection';
import MenuList from './MenuList';
export default function Sidebar({
  desktop,
  drawerOpen,
  onClose,
  onNavigate
}) {
  return <Box component="nav" aria-label={t("Navegação principal")} sx={{
    width: desktop ? portalConfig.drawerWidth : 0,
    flexShrink: 0,
    transition: theme => theme.transitions.create('width')
  }}>
            <Drawer id="portal-sidebar" variant={desktop ? 'permanent' : 'temporary'} anchor="left" open={drawerOpen} onClose={onClose} ModalProps={{
      keepMounted: true
    }} sx={{
      '& .MuiDrawer-paper': {
        width: portalConfig.drawerWidth,
        background: `linear-gradient(180deg, ${portalBrand.main}, ${portalBrand.accent})`,
        color: '#fff',
        borderRight: 'none'
      }
    }}>
                <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0
      }}>
                    <Box sx={{
          display: 'flex',
          alignItems: 'center',
          height: 80,
          flexShrink: 0,
          px: 2,
          py: 2
        }}>
                        <LogoSection onNavigate={onNavigate} />
                    </Box>
                    <Divider sx={{
          borderColor: 'white',
          width: '100%',
          mx: 'auto'
        }} />
                    <Box sx={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto'
        }}>
                        <MenuList onNavigate={onNavigate} />
                    </Box>
                    <Box sx={{
          mt: 'auto',
          textAlign: 'center',
          px: 1,
          pb: 2,
          pt: 3
        }}>
                        <Typography variant="body2" sx={{
            color: 'white',
            mb: 1
          }}>{t("POWERED BY")}</Typography>
                        <CompanySection />
                        <Typography variant="caption" sx={{
            display: 'block',
            color: 'white',
            opacity: 0.7,
            mt: 1
          }}>{t("v")}{APP_VERSION}
                        </Typography>
                    </Box>
                </Box>
            </Drawer>
        </Box>;
}
Sidebar.propTypes = {
  desktop: PropTypes.bool.isRequired,
  drawerOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onNavigate: PropTypes.func.isRequired
};
